import gql from 'graphql-tag';
export default gql`
  mutation reassignQuote($userInfo: UserInput!) {
    reassignQuote(userInfo: $userInfo) {
      status
      message
    }
  }
`;
